// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { N0 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var aiFloatingToolbarCss = css({
  backgroundColor: "var(--ds-surface-overlay, ".concat(N0, ")"),
  padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-150, 12px)"),
  display: 'flex',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& p': {
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-subtlest, #626F86)",
    marginRight: "var(--ds-space-050, 4px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var footerContentContainer = css({
  display: 'flex',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '& p': {
    margin: 0,
    padding: "0 ".concat("var(--ds-space-050, 4px)", " 0 0")
  }
});